import React, { useContext, useEffect } from 'react';
import { AppSettings } from './../../config/app-settings.js';

function ExtraFileManager() {
	const context = useContext(AppSettings);

	useEffect(() => {
		context.handleSetAppSidebarMinified(true);
		context.handleSetAppHeaderInverse(true);
		context.handleSetAppContentFullHeight(true);

		const mobileToggle = document.querySelector('[data-toggle-class="file-manager-sidebar-mobile-toggled"]');
		const handleMobileToggle = (event) => {
			event.preventDefault();
			document.querySelector('#fileManager')?.classList.toggle('file-manager-sidebar-mobile-toggled');
		};
		mobileToggle?.addEventListener('click', handleMobileToggle);

		const fileNodes = [...document.querySelectorAll('#fileManager .file-node')];
		const fileNodeHandlers = [];
		fileNodes.forEach((node) => {
			const arrow = node.querySelector(':scope > .file-link > .file-arrow');
			const info = node.querySelector(':scope > .file-link > .file-info');
			if (arrow) {
				const handleArrow = (event) => {
					event.preventDefault();
					node.classList.toggle('expand');
				};
				arrow.addEventListener('click', handleArrow);
				fileNodeHandlers.push(() => arrow.removeEventListener('click', handleArrow));
			}
			if (info) {
				const handleInfo = (event) => {
					event.preventDefault();
					fileNodes.forEach((otherNode) => otherNode.classList.remove('selected'));
					node.classList.add('selected', 'expand');
				};
				info.addEventListener('click', handleInfo);
				fileNodeHandlers.push(() => info.removeEventListener('click', handleInfo));
			}
		});

		return () => {
			mobileToggle?.removeEventListener('click', handleMobileToggle);
			fileNodeHandlers.forEach((cleanup) => cleanup());
			context.handleSetAppSidebarMinified(false);
			context.handleSetAppHeaderInverse(false);
			context.handleSetAppContentFullHeight(false);
			context.handleSetAppContentClass('');
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div>
			<div>
							
							<ol className="breadcrumb float-xl-end">
								<li className="breadcrumb-item"><a href="#/">Home</a></li>
								<li className="breadcrumb-item"><a href="#/">Pages</a></li>
								<li className="breadcrumb-item active">File Manager</li>
							</ol>
							
							
							<h1 className="page-header">File Manager <small>page header description goes here...</small></h1>
							
						</div>
						
						<div className="card rounded-3 card-borderless flex-1 m-0 d-flex flex-column overflow-hidden">
							<div className="card-header bg-gray-900">
								<h4 className="card-header-title text-white">File Manager</h4>
								<div className="card-header-btn">
									<a href="#/" className="btn btn-xs btn-icon btn-default" data-toggle="card-expand"><i className="fa fa-expand"></i></a>
									<a href="#/" className="btn btn-xs btn-icon btn-success" data-toggle="card-reload"><i className="fa fa-redo"></i></a>
									<a href="#/" className="btn btn-xs btn-icon btn-warning" data-toggle="card-collapse"><i className="fa fa-minus"></i></a>
									<a href="#/" className="btn btn-xs btn-icon btn-danger" data-toggle="card-remove"><i className="fa fa-times"></i></a>
								</div>
							</div>
							<div className="card-body p-0 flex-1 overflow-hidden">
								<div className="file-manager h-100" id="fileManager">
									<div className="file-manager-toolbar">
										 <button type="button" className="btn shadow-none text-body border-0 d-flex gap-2 align-items-center"><iconify-icon icon="solar:add-circle-bold-duotone" className="fs-4"></iconify-icon> File</button>
										 <button type="button" className="btn shadow-none text-body border-0 d-flex gap-2 align-items-center"><iconify-icon icon="solar:add-circle-bold-duotone" className="fs-4"></iconify-icon> Folder</button>
										 <button type="button" className="btn shadow-none text-body border-0 d-flex gap-2 align-items-center" disabled><iconify-icon icon="solar:copy-bold-duotone" className="fs-4"></iconify-icon> Copy</button>
										 <button type="button" className="btn shadow-none text-body border-0 d-flex gap-2 align-items-center" disabled><iconify-icon icon="solar:cursor-bold-duotone" className="fs-4"></iconify-icon> Move</button>
										 <button type="button" className="btn shadow-none text-body border-0 d-flex gap-2 align-items-center"><iconify-icon icon="solar:upload-bold-duotone" className="fs-4"></iconify-icon> Upload</button>
										 <button type="button" className="btn shadow-none text-body border-0 d-flex gap-2 align-items-center" disabled><iconify-icon icon="solar:download-bold-duotone" className="fs-4"></iconify-icon> Download</button>
										 <button type="button" className="btn shadow-none text-body border-0 d-flex gap-2 align-items-center" disabled><iconify-icon icon="solar:trash-bin-trash-bold-duotone" className="fs-4"></iconify-icon> Delete</button>
										 <button type="button" className="btn shadow-none text-body border-0 d-flex gap-2 align-items-center" disabled><iconify-icon icon="solar:restart-bold-duotone" className="fs-4"></iconify-icon> Restore</button>
										 <button type="button" className="btn shadow-none text-body border-0 d-flex gap-2 align-items-center" disabled><iconify-icon icon="solar:file-bold-duotone" className="fs-4"></iconify-icon> Rename</button>
										 <button type="button" className="btn shadow-none text-body border-0 d-flex gap-2 align-items-center" disabled><iconify-icon icon="solar:pen-new-square-bold-duotone" className="fs-4"></iconify-icon> Edit</button>
										 <button type="button" className="btn shadow-none text-body border-0 d-flex gap-2 align-items-center" disabled><iconify-icon icon="solar:ruler-pen-bold-duotone" className="fs-4"></iconify-icon> HTML Editor</button>
										 <button type="button" className="btn shadow-none text-body border-0 d-flex gap-2 align-items-center" disabled><iconify-icon icon="solar:key-bold-duotone" className="fs-4"></iconify-icon> Permissions</button>
										 <button type="button" className="btn shadow-none text-body border-0 d-flex gap-2 align-items-center" disabled><iconify-icon icon="solar:eye-bold-duotone" className="fs-4"></iconify-icon> View</button>
										 <button type="button" className="btn shadow-none text-body border-0 d-flex gap-2 align-items-center" disabled><iconify-icon icon="solar:lock-keyhole-minimalistic-unlocked-bold-duotone" className="fs-4"></iconify-icon> Extract</button>
										 <button type="button" className="btn shadow-none text-body border-0 d-flex gap-2 align-items-center" disabled><iconify-icon icon="solar:zip-file-bold-duotone" className="fs-4"></iconify-icon> Compress</button>
									</div>
									<div className="file-manager-container">
										<div className="file-manager-sidebar">
											<div className="file-manager-sidebar-mobile-toggler">
												<button type="button" className="btn" data-toggle-class="file-manager-sidebar-mobile-toggled" data-toggle-target="#fileManager"><i className="far fa-lg fa-folder"></i></button>
											</div>
											<div>
												<input type="text" className="form-control" placeholder="Seach file..." />
											</div>
											<div className="file-manager-sidebar-content">
												<div data-scrollbar="true" data-height="100%">
													<div className="file-tree">
														<div className="file-node has-sub expand selected">
															<a href="#/" className="file-link">
																<span className="file-arrow"></span>
																<span className="file-info">
																	<span className="file-icon"><iconify-icon icon="solar:folder-with-files-bold-duotone" className="text-warning"></iconify-icon></span>
																	<span className="file-text">public_html</span>
																</span>
															</a>
															<div className="file-tree">
																<div className="file-node has-sub">
																	<a href="#/" className="file-link">
																		<span className="file-arrow"></span>
																		<span className="file-info">
																			<span className="file-icon"><iconify-icon icon="solar:folder-with-files-bold-duotone" className="text-warning"></iconify-icon></span>
																			<span className="file-text">services</span>
																		</span>
																	</a>
																	<div className="file-tree">
																		<div className="file-node has-sub">
																			<a href="#/" className="file-link">
																				<span className="file-arrow"></span>
																				<span className="file-info">
																					<span className="file-icon"><iconify-icon icon="solar:folder-with-files-bold-duotone" className="text-warning"></iconify-icon></span>
																					<span className="file-text">app_development</span>
																				</span>
																			</a>
																			<div className="file-tree">
																				<div className="file-node">
																					<a href="#/" className="file-link">
																						<span className="file-arrow"></span>
																						<span className="file-info">
																							<span className="file-icon"><iconify-icon icon="solar:code-file-bold-duotone" className="text-secondary"></iconify-icon></span>
																							<span className="file-text">index.html</span>
																						</span>
																					</a>
																				</div>
																				<div className="file-node">
																					<a href="#/" className="file-link">
																						<span className="file-arrow"></span>
																						<span className="file-info">
																							<span className="file-icon"><iconify-icon icon="solar:code-file-bold-duotone" className="text-secondary"></iconify-icon></span>
																							<span className="file-text">android_app.html</span>
																						</span>
																					</a>
																				</div>
																				<div className="file-node">
																					<a href="#/" className="file-link">
																						<span className="file-arrow"></span>
																						<span className="file-info">
																							<span className="file-icon"><iconify-icon icon="solar:code-file-bold-duotone" className="text-secondary"></iconify-icon></span>
																							<span className="file-text">ios_app.html</span>
																						</span>
																					</a>
																				</div>
																			</div>
																		</div>
																		<div className="file-node has-sub">
																			<a href="#/" className="file-link">
																				<span className="file-arrow"></span>
																				<span className="file-info">
																					<span className="file-icon"><iconify-icon icon="solar:folder-with-files-bold-duotone" className="text-warning"></iconify-icon></span>
																					<span className="file-text">digital_marketing</span>
																				</span>
																			</a>
																			<div className="file-tree">
																				<div className="file-node">
																					<a href="#/" className="file-link">
																						<span className="file-arrow"></span>
																						<span className="file-info">
																							<span className="file-icon"><iconify-icon icon="solar:code-file-bold-duotone" className="text-secondary"></iconify-icon></span>
																							<span className="file-text">index.html</span>
																						</span>
																					</a>
																				</div>
																				<div className="file-node">
																					<a href="#/" className="file-link">
																						<span className="file-arrow"></span>
																						<span className="file-info">
																							<span className="file-icon"><iconify-icon icon="solar:code-file-bold-duotone" className="text-secondary"></iconify-icon></span>
																							<span className="file-text">social_media.html</span>
																						</span>
																					</a>
																				</div>
																				<div className="file-node">
																					<a href="#/" className="file-link">
																						<span className="file-arrow"></span>
																						<span className="file-info">
																							<span className="file-icon"><iconify-icon icon="solar:code-file-bold-duotone" className="text-secondary"></iconify-icon></span>
																							<span className="file-text">seo.html</span>
																						</span>
																					</a>
																				</div>
																			</div>
																		</div>
																		<div className="file-node">
																			<a href="#/" className="file-link">
																				<span className="file-arrow"></span>
																				<span className="file-info">
																					<span className="file-icon"><iconify-icon icon="solar:code-file-bold-duotone" className="text-secondary"></iconify-icon></span>
																					<span className="file-text">index.html</span>
																				</span>
																			</a>
																		</div>
																		<div className="file-node">
																			<a href="#/" className="file-link">
																				<span className="file-arrow"></span>
																				<span className="file-info">
																					<span className="file-icon"><iconify-icon icon="solar:code-file-bold-duotone" className="text-secondary"></iconify-icon></span>
																					<span className="file-text">web_design.html</span>
																				</span>
																			</a>
																		</div>
																		<div className="file-node">
																			<a href="#/" className="file-link">
																				<span className="file-arrow"></span>
																				<span className="file-info">
																					<span className="file-icon"><iconify-icon icon="solar:code-file-bold-duotone" className="text-secondary"></iconify-icon></span>
																					<span className="file-text">seo_services.html</span>
																				</span>
																			</a>
																		</div>
																	</div>
																</div>
																<div className="file-node has-sub">
																	<a href="#/" className="file-link">
																		<span className="file-arrow"></span>
																		<span className="file-info">
																			<span className="file-icon"><iconify-icon icon="solar:folder-with-files-bold-duotone" className="text-warning"></iconify-icon></span>
																			<span className="file-text">portfolio</span>
																		</span>
																	</a>
																	<div className="file-tree">
																		<div className="file-node">
																			<a href="#/" className="file-link">
																				<span className="file-arrow"></span>
																				<span className="file-info">
																					<span className="file-icon"><iconify-icon icon="solar:code-file-bold-duotone" className="text-secondary"></iconify-icon></span>
																					<span className="file-text">index.html</span>
																				</span>
																			</a>
																		</div>
																		<div className="file-node">
																			<a href="#/" className="file-link">
																				<span className="file-arrow"></span>
																				<span className="file-info">
																					<span className="file-icon"><iconify-icon icon="solar:code-file-bold-duotone" className="text-secondary"></iconify-icon></span>
																					<span className="file-text">project_1.html</span>
																				</span>
																			</a>
																		</div>
																		<div className="file-node">
																			<a href="#/" className="file-link">
																				<span className="file-arrow"></span>
																				<span className="file-info">
																					<span className="file-icon"><iconify-icon icon="solar:code-file-bold-duotone" className="text-secondary"></iconify-icon></span>
																					<span className="file-text">project_2.html</span>
																				</span>
																			</a>
																		</div>
																		<div className="file-node">
																			<a href="#/" className="file-link">
																				<span className="file-arrow"></span>
																				<span className="file-info">
																					<span className="file-icon"><iconify-icon icon="solar:code-file-bold-duotone" className="text-secondary"></iconify-icon></span>
																					<span className="file-text">project_3.html</span>
																				</span>
																			</a>
																		</div>
																		<div className="file-node">
																			<a href="#/" className="file-link">
																				<span className="file-arrow"></span>
																				<span className="file-info">
																					<span className="file-icon"><iconify-icon icon="solar:code-file-bold-duotone" className="text-secondary"></iconify-icon></span>
																					<span className="file-text">project_4.html</span>
																				</span>
																			</a>
																		</div>
																		<div className="file-node">
																			<a href="#/" className="file-link">
																				<span className="file-arrow"></span>
																				<span className="file-info">
																					<span className="file-icon"><iconify-icon icon="solar:code-file-bold-duotone" className="text-secondary"></iconify-icon></span>
																					<span className="file-text">project_5.html</span>
																				</span>
																			</a>
																		</div>
																	</div>
																</div>
																<div className="file-node has-sub">
																	<a href="#/" className="file-link">
																		<span className="file-arrow"></span>
																		<span className="file-info">
																			<span className="file-icon"><iconify-icon icon="solar:folder-with-files-bold-duotone" className="text-warning"></iconify-icon></span>
																			<span className="file-text">blog</span>
																		</span>
																	</a>
																	<div className="file-tree">
																		<div className="file-node">
																			<a href="#/" className="file-link">
																				<span className="file-arrow"></span>
																				<span className="file-info">
																					<span className="file-icon"><iconify-icon icon="solar:code-file-bold-duotone" className="text-secondary"></iconify-icon></span>
																					<span className="file-text">index.html</span>
																				</span>
																			</a>
																		</div>
																		<div className="file-node">
																			<a href="#/" className="file-link">
																				<span className="file-arrow"></span>
																				<span className="file-info">
																					<span className="file-icon"><iconify-icon icon="solar:code-file-bold-duotone" className="text-secondary"></iconify-icon></span>
																					<span className="file-text">post_1.html</span>
																				</span>
																			</a>
																		</div>
																		<div className="file-node">
																			<a href="#/" className="file-link">
																				<span className="file-arrow"></span>
																				<span className="file-info">
																					<span className="file-icon"><iconify-icon icon="solar:code-file-bold-duotone" className="text-secondary"></iconify-icon></span>
																					<span className="file-text">post_2.html</span>
																				</span>
																			</a>
																		</div>
																		<div className="file-node">
																			<a href="#/" className="file-link">
																				<span className="file-arrow"></span>
																				<span className="file-info">
																					<span className="file-icon"><iconify-icon icon="solar:code-file-bold-duotone" className="text-secondary"></iconify-icon></span>
																					<span className="file-text">post_3.html</span>
																				</span>
																			</a>
																		</div>
																		<div className="file-node">
																			<a href="#/" className="file-link">
																				<span className="file-arrow"></span>
																				<span className="file-info">
																					<span className="file-icon"><iconify-icon icon="solar:code-file-bold-duotone" className="text-secondary"></iconify-icon></span>
																					<span className="file-text">post_4.html</span>
																				</span>
																			</a>
																		</div>
																		<div className="file-node">
																			<a href="#/" className="file-link">
																				<span className="file-arrow"></span>
																				<span className="file-info">
																					<span className="file-icon"><iconify-icon icon="solar:code-file-bold-duotone" className="text-secondary"></iconify-icon></span>
																					<span className="file-text">post_5.html</span>
																				</span>
																			</a>
																		</div>
																	</div>
																</div>
																<div className="file-node has-sub">
																	<a href="#/" className="file-link">
																		<span className="file-arrow"></span>
																		<span className="file-info">
																			<span className="file-icon"><iconify-icon icon="solar:folder-with-files-bold-duotone" className="text-warning"></iconify-icon></span>
																			<span className="file-text">assets</span>
																		</span>
																	</a>
																	<div className="file-tree">
																		<div className="file-node has-sub">
																			<a href="#/" className="file-link">
																				<span className="file-arrow"></span>
																				<span className="file-info">
																					<span className="file-icon"><iconify-icon icon="solar:folder-with-files-bold-duotone" className="text-warning"></iconify-icon></span>
																					<span className="file-text">css</span>
																				</span>
																			</a>
																			<div className="file-tree">
																				<div className="file-node">
																					<a href="#/" className="file-link">
																						<span className="file-arrow"></span>
																						<span className="file-info">
																							<span className="file-icon"><iconify-icon icon="solar:file-text-bold-duotone" className="text-secondary"></iconify-icon></span>
																							<span className="file-text">styles.css</span>
																						</span>
																					</a>
																				</div>
																				<div className="file-node">
																					<a href="#/" className="file-link">
																						<span className="file-arrow"></span>
																						<span className="file-info">
																							<span className="file-icon"><iconify-icon icon="solar:file-text-bold-duotone" className="text-secondary"></iconify-icon></span>
																							<span className="file-text">main.css</span>
																						</span>
																					</a>
																				</div>
																				<div className="file-node">
																					<a href="#/" className="file-link">
																						<span className="file-arrow"></span>
																						<span className="file-info">
																							<span className="file-icon"><iconify-icon icon="solar:file-text-bold-duotone" className="text-secondary"></iconify-icon></span>
																							<span className="file-text">responsive.css</span>
																						</span>
																					</a>
																				</div>
																				<div className="file-node">
																					<a href="#/" className="file-link">
																						<span className="file-arrow"></span>
																						<span className="file-info">
																							<span className="file-icon"><iconify-icon icon="solar:file-text-bold-duotone" className="text-secondary"></iconify-icon></span>
																							<span className="file-text">typography.css</span>
																						</span>
																					</a>
																				</div>
																				<div className="file-node">
																					<a href="#/" className="file-link">
																						<span className="file-arrow"></span>
																						<span className="file-info">
																							<span className="file-icon"><iconify-icon icon="solar:file-text-bold-duotone" className="text-secondary"></iconify-icon></span>
																							<span className="file-text">colors.css</span>
																						</span>
																					</a>
																				</div>
																				<div className="file-node">
																					<a href="#/" className="file-link">
																						<span className="file-arrow"></span>
																						<span className="file-info">
																							<span className="file-icon"><iconify-icon icon="solar:file-text-bold-duotone" className="text-secondary"></iconify-icon></span>
																							<span className="file-text">layout.css</span>
																						</span>
																					</a>
																				</div>
																				<div className="file-node">
																					<a href="#/" className="file-link">
																						<span className="file-arrow"></span>
																						<span className="file-info">
																							<span className="file-icon"><iconify-icon icon="solar:file-text-bold-duotone" className="text-secondary"></iconify-icon></span>
																							<span className="file-text">animations.css</span>
																						</span>
																					</a>
																				</div>
																				<div className="file-node">
																					<a href="#/" className="file-link">
																						<span className="file-arrow"></span>
																						<span className="file-info">
																							<span className="file-icon"><iconify-icon icon="solar:file-text-bold-duotone" className="text-secondary"></iconify-icon></span>
																							<span className="file-text">forms.css</span>
																						</span>
																					</a>
																				</div>
																				<div className="file-node">
																					<a href="#/" className="file-link">
																						<span className="file-arrow"></span>
																						<span className="file-info">
																							<span className="file-icon"><iconify-icon icon="solar:file-text-bold-duotone" className="text-secondary"></iconify-icon></span>
																							<span className="file-text">buttons.css</span>
																						</span>
																					</a>
																				</div>
																				<div className="file-node">
																					<a href="#/" className="file-link">
																						<span className="file-arrow"></span>
																						<span className="file-info">
																							<span className="file-icon"><iconify-icon icon="solar:file-text-bold-duotone" className="text-secondary"></iconify-icon></span>
																							<span className="file-text">grids.css</span>
																						</span>
																					</a>
																				</div>
																			</div>
																		</div>
																		<div className="file-node has-sub">
																			<a href="#/" className="file-link">
																				<span className="file-arrow"></span>
																				<span className="file-info">
																					<span className="file-icon"><iconify-icon icon="solar:folder-with-files-bold-duotone" className="text-warning"></iconify-icon></span>
																					<span className="file-text">js</span>
																				</span>
																			</a>
																			<div className="file-tree">
																				<div className="file-node">
																					<a href="#/" className="file-link">
																						<span className="file-arrow"></span>
																						<span className="file-info">
																							<span className="file-icon"><iconify-icon icon="solar:file-text-bold-duotone" className="text-secondary"></iconify-icon></span>
																							<span className="file-text">main.js</span>
																						</span>
																					</a>
																				</div>
																				<div className="file-node">
																					<a href="#/" className="file-link">
																						<span className="file-arrow"></span>
																						<span className="file-info">
																							<span className="file-icon"><iconify-icon icon="solar:file-text-bold-duotone" className="text-secondary"></iconify-icon></span>
																							<span className="file-text">script.js</span>
																						</span>
																					</a>
																				</div>
																				<div className="file-node">
																					<a href="#/" className="file-link">
																						<span className="file-arrow"></span>
																						<span className="file-info">
																							<span className="file-icon"><iconify-icon icon="solar:file-text-bold-duotone" className="text-secondary"></iconify-icon></span>
																							<span className="file-text">sliders.js</span>
																						</span>
																					</a>
																				</div>
																				<div className="file-node">
																					<a href="#/" className="file-link">
																						<span className="file-arrow"></span>
																						<span className="file-info">
																							<span className="file-icon"><iconify-icon icon="solar:file-text-bold-duotone" className="text-secondary"></iconify-icon></span>
																							<span className="file-text">gallery.js</span>
																						</span>
																					</a>
																				</div>
																				<div className="file-node">
																					<a href="#/" className="file-link">
																						<span className="file-arrow"></span>
																						<span className="file-info">
																							<span className="file-icon"><iconify-icon icon="solar:file-text-bold-duotone" className="text-secondary"></iconify-icon></span>
																							<span className="file-text">form-validation.js</span>
																						</span>
																					</a>
																				</div>
																				<div className="file-node">
																					<a href="#/" className="file-link">
																						<span className="file-arrow"></span>
																						<span className="file-info">
																							<span className="file-icon"><iconify-icon icon="solar:file-text-bold-duotone" className="text-secondary"></iconify-icon></span>
																							<span className="file-text">animations.js</span>
																						</span>
																					</a>
																				</div>
																				<div className="file-node">
																					<a href="#/" className="file-link">
																						<span className="file-arrow"></span>
																						<span className="file-info">
																							<span className="file-icon"><iconify-icon icon="solar:file-text-bold-duotone" className="text-secondary"></iconify-icon></span>
																							<span className="file-text">navigation.js</span>
																						</span>
																					</a>
																				</div>
																				<div className="file-node">
																					<a href="#/" className="file-link">
																						<span className="file-arrow"></span>
																						<span className="file-info">
																							<span className="file-icon"><iconify-icon icon="solar:file-text-bold-duotone" className="text-secondary"></iconify-icon></span>
																							<span className="file-text">modal.js</span>
																						</span>
																					</a>
																				</div>
																				<div className="file-node">
																					<a href="#/" className="file-link">
																						<span className="file-arrow"></span>
																						<span className="file-info">
																							<span className="file-icon"><iconify-icon icon="solar:file-text-bold-duotone" className="text-secondary"></iconify-icon></span>
																							<span className="file-text">tabs.js</span>
																						</span>
																					</a>
																				</div>
																				<div className="file-node">
																					<a href="#/" className="file-link">
																						<span className="file-arrow"></span>
																						<span className="file-info">
																							<span className="file-icon"><iconify-icon icon="solar:file-text-bold-duotone" className="text-secondary"></iconify-icon></span>
																							<span className="file-text">accordion.js</span>
																						</span>
																					</a>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
																<div className="file-node">
																	<a href="#/" className="file-link">
																		<span className="file-arrow"></span>
																		<span className="file-info">
																			<span className="file-icon"><iconify-icon icon="solar:code-file-bold-duotone" className="text-secondary"></iconify-icon></span>
																			<span className="file-text">index.html</span>
																		</span>
																	</a>
																</div>
																<div className="file-node">
																	<a href="#/" className="file-link">
																		<span className="file-arrow"></span>
																		<span className="file-info">
																			<span className="file-icon"><iconify-icon icon="solar:code-file-bold-duotone" className="text-secondary"></iconify-icon></span>
																			<span className="file-text">home.html</span>
																		</span>
																	</a>
																</div>
																<div className="file-node">
																	<a href="#/" className="file-link">
																		<span className="file-arrow"></span>
																		<span className="file-info">
																			<span className="file-icon"><iconify-icon icon="solar:code-file-bold-duotone" className="text-secondary"></iconify-icon></span>
																			<span className="file-text">about.html</span>
																		</span>
																	</a>
																</div>
																<div className="file-node">
																	<a href="#/" className="file-link">
																		<span className="file-arrow"></span>
																		<span className="file-info">
																			<span className="file-icon"><iconify-icon icon="solar:code-file-bold-duotone" className="text-secondary"></iconify-icon></span>
																			<span className="file-text">contact.html</span>
																		</span>
																	</a>
																</div>
																<div className="file-node">
																	<a href="#/" className="file-link">
																		<span className="file-arrow"></span>
																		<span className="file-info">
																			<span className="file-icon"><iconify-icon icon="solar:code-file-bold-duotone" className="text-secondary"></iconify-icon></span>
																			<span className="file-text">testimonials.html</span>
																		</span>
																	</a>
																</div>
																<div className="file-node">
																	<a href="#/" className="file-link">
																		<span className="file-arrow"></span>
																		<span className="file-info">
																			<span className="file-icon"><iconify-icon icon="solar:code-file-bold-duotone" className="text-secondary"></iconify-icon></span>
																			<span className="file-text">faq.html</span>
																		</span>
																	</a>
																</div>
																<div className="file-node">
																	<a href="#/" className="file-link">
																		<span className="file-arrow"></span>
																		<span className="file-info">
																			<span className="file-icon"><iconify-icon icon="solar:code-file-bold-duotone" className="text-secondary"></iconify-icon></span>
																			<span className="file-text">pricing.html</span>
																		</span>
																	</a>
																</div>
																<div className="file-node">
																	<a href="#/" className="file-link">
																		<span className="file-arrow"></span>
																		<span className="file-info">
																			<span className="file-icon"><iconify-icon icon="solar:code-file-bold-duotone" className="text-secondary"></iconify-icon></span>
																			<span className="file-text">404.shtml</span>
																		</span>
																	</a>
																</div>
																<div className="file-node">
																	<a href="#/" className="file-link">
																		<span className="file-arrow"></span>
																		<span className="file-info">
																			<span className="file-icon"><iconify-icon icon="solar:file-text-bold-duotone" className="text-success"></iconify-icon></span>
																			<span className="file-text">.htaccess</span>
																		</span>
																	</a>
																</div>
																<div className="file-node">
																	<a href="#/" className="file-link">
																		<span className="file-arrow"></span>
																		<span className="file-info">
																			<span className="file-icon"><iconify-icon icon="solar:camera-bold-duotone" className="text-indigo"></iconify-icon></span>
																			<span className="file-text">favicon.ico</span>
																		</span>
																	</a>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div className="file-manager-sidebar-footer">
												<div className="d-flex align-items-center gap-3">
													<div>
														<iconify-icon className="fa-3x" icon="solar:ssd-square-line-duotone"></iconify-icon>
													</div>
													<div className="flex-1 small">
														<div className="fw-bold">SSD Storage:</div>
														<div className="progress h-5px my-1">
															<div className="progress-bar progress-bar-striped bg-warning" style={{ width: '80%' }}></div>
														</div>
														<div className="fw-bold text-body text-opacity-75">
															<b className="text-body">51.2GB</b> free of <b className="text-body">256GB</b>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div className="file-manager-content d-flex flex-column">
											<div className="mb-3 d-flex text-nowrap flex-wrap gap-2">
												<button type="button" className="btn btn-white"><iconify-icon icon="solar:widget-bold-duotone" className="d-block fa-lg"></iconify-icon></button>
												<button type="button" className="btn btn-white d-flex align-items-center gap-2" disabled><iconify-icon icon="solar:arrow-to-top-left-bold-duotone" className="d-block fa-lg"></iconify-icon>  Up One Level</button>
										
												<div className="btn-group">
													<button type="button" className="btn btn-white d-flex align-items-center gap-2" disabled><iconify-icon icon="solar:arrow-left-linear" className="d-block fa-lg"></iconify-icon> Back</button>
													<button type="button" className="btn btn-white d-flex align-items-center gap-2" disabled><iconify-icon icon="solar:arrow-right-linear" className="d-block fa-lg"></iconify-icon> Forward</button>
												</div>
												<button type="button" className="btn btn-white"><iconify-icon icon="solar:refresh-bold-duotone" className="d-block fa-lg"></iconify-icon></button>
										
												<div className="btn-group">
													<button type="button" className="btn btn-white d-flex align-items-center gap-2"><iconify-icon icon="solar:check-read-linear" className="d-block fa-lg"></iconify-icon> Select All</button>
													<button type="button" className="btn btn-white d-flex align-items-center gap-2"><iconify-icon icon="solar:close-square-linear" className="d-block fa-lg"></iconify-icon> Unselect All</button>
												</div>
											</div>
											<div className="flex-1 overflow-hidden">
												<div data-scrollbar="true" data-skip-mobile="true" data-height="100%" className="p-0">
													<table className="table table-borderless table-py-4px table-striped table-card fw-semibold m-0 text-nowrap">
														<thead>
															<tr>
																<th className="w-10px ps-10px"></th>
																<th>Name</th>
																<th className="w-100px">Size</th>
																<th className="w-200px">Last Modified</th>
																<th className="w-200px">Type</th>
																<th className="w-100px">Permission</th>
															</tr>
														</thead>
														<tbody>
															<tr>
																<td className="text-center"><iconify-icon icon="solar:folder-with-files-bold-duotone" className="text-warning d-block fs-20px"></iconify-icon></td>
																<td>services</td>
																<td>4 KB</td>
																<td>Jun 11, 2026, 10:35PM</td>
																<td>http:/unix-directory</td>
																<td>0755</td>
															</tr>
															<tr>
																<td className="text-center"><iconify-icon icon="solar:folder-with-files-bold-duotone" className="text-warning d-block fs-20px"></iconify-icon></td>
																<td>portfolio</td>
																<td>4 KB</td>
																<td>Jun 11, 2026, 10:36PM</td>
																<td>http:/unix-directory</td>
																<td>0755</td>
															</tr>
															<tr>
																<td className="text-center"><iconify-icon icon="solar:folder-with-files-bold-duotone" className="text-warning d-block fs-20px"></iconify-icon></td>
																<td>blog</td>
																<td>4 KB</td>
																<td>Jun 11, 2026, 10:04PM</td>
																<td>http:/unix-directory</td>
																<td>0755</td>
															</tr>
															<tr>
																<td className="text-center"><iconify-icon icon="solar:folder-with-files-bold-duotone" className="text-warning d-block fs-20px"></iconify-icon></td>
																<td>assets</td>
																<td>4 KB</td>
																<td>Jun 11, 2026, 10:14PM</td>
																<td>http:/unix-directory</td>
																<td>0755</td>
															</tr>
															<tr>
																<td className="text-center"><iconify-icon icon="solar:folder-with-files-bold-duotone" className="text-warning d-block fs-20px"></iconify-icon></td>
																<td>php</td>
																<td>4 KB</td>
																<td>Jun 11, 2026, 10:36PM</td>
																<td>http:/unix-directory</td>
																<td>0755</td>
															</tr>
															<tr>
																<td className="text-center"><iconify-icon icon="solar:folder-with-files-bold-duotone" className="text-warning d-block fs-20px"></iconify-icon></td>
																<td>docs</td>
																<td>4 KB</td>
																<td>Jun 11, 2026, 10:36PM</td>
																<td>http:/unix-directory</td>
																<td>0755</td>
															</tr>
															<tr>
																<td className="text-center"><iconify-icon icon="solar:folder-with-files-bold-duotone" className="text-warning d-block fs-20px"></iconify-icon></td>
																<td>archives</td>
																<td>4 KB</td>
																<td>Jun 11, 2026, 10:36PM</td>
																<td>http:/unix-directory</td>
																<td>0755</td>
															</tr>
															<tr>
																<td className="text-center"><iconify-icon icon="solar:folder-with-files-bold-duotone" className="text-warning d-block fs-20px"></iconify-icon></td>
																<td>video</td>
																<td>4 KB</td>
																<td>Jun 11, 2026, 10:36PM</td>
																<td>http:/unix-directory</td>
																<td>0755</td>
															</tr>
															<tr>
																<td className="text-center"><iconify-icon icon="solar:folder-with-files-bold-duotone" className="text-warning d-block fs-20px"></iconify-icon></td>
																<td>audio</td>
																<td>4 KB</td>
																<td>Jun 11, 2026, 10:36PM</td>
																<td>http:/unix-directory</td>
																<td>0755</td>
															</tr>
															<tr>
																<td className="text-center"><iconify-icon icon="solar:folder-with-files-bold-duotone" className="text-warning d-block fs-20px"></iconify-icon></td>
																<td>docs</td>
																<td>4 KB</td>
																<td>Jun 11, 2026, 10:36PM</td>
																<td>http:/unix-directory</td>
																<td>0755</td>
															</tr>
															<tr>
																<td className="text-center"><iconify-icon icon="solar:code-file-bold-duotone" className="text-secondary d-block fs-20px"></iconify-icon></td>
																<td>index.html</td>
																<td>39.5 KB</td>
																<td>July 05, 2026, 10:35PM</td>
																<td>text/html</td>
																<td>0644</td>
															</tr>
															<tr>
																<td className="text-center"><iconify-icon icon="solar:code-file-bold-duotone" className="text-secondary d-block fs-20px"></iconify-icon></td>
																<td>home.html</td>
																<td>129.1 KB</td>
																<td>July 06, 2026, 1:00PM</td>
																<td>text/html</td>
																<td>0644</td>
															</tr>
															<tr>
																<td className="text-center"><iconify-icon icon="solar:code-file-bold-duotone" className="text-secondary d-block fs-20px"></iconify-icon></td>
																<td>about.html</td>
																<td>24 KB</td>
																<td>July 01, 2026, 6:59AM</td>
																<td>text/html</td>
																<td>0644</td>
															</tr>
															<tr>
																<td className="text-center"><iconify-icon icon="solar:code-file-bold-duotone" className="text-secondary d-block fs-20px"></iconify-icon></td>
																<td>contact.html</td>
																<td>39.5 KB</td>
																<td>July 05, 2026, 10:35PM</td>
																<td>text/html</td>
																<td>0644</td>
															</tr>
															<tr>
																<td className="text-center"><iconify-icon icon="solar:code-file-bold-duotone" className="text-secondary d-block fs-20px"></iconify-icon></td>
																<td>testimonials.html</td>
																<td>11 KB</td>
																<td>July 05, 2026, 10:35PM</td>
																<td>text/html</td>
																<td>0644</td>
															</tr>
															<tr>
																<td className="text-center"><iconify-icon icon="solar:code-file-bold-duotone" className="text-secondary d-block fs-20px"></iconify-icon></td>
																<td>faq.html</td>
																<td>12 KB</td>
																<td>July 05, 2026, 1.59PM</td>
																<td>text/html</td>
																<td>0644</td>
															</tr>
															<tr>
																<td className="text-center"><iconify-icon icon="solar:code-file-bold-duotone" className="text-secondary d-block fs-20px"></iconify-icon></td>
																<td>pricing.html</td>
																<td>128 KB</td>
																<td>July 05, 2026, 12.49PM</td>
																<td>text/html</td>
																<td>0644</td>
															</tr>
															<tr>
																<td className="text-center"><iconify-icon icon="solar:code-file-bold-duotone" className="text-secondary d-block fs-20px"></iconify-icon></td>
																<td>404.shtml</td>
																<td>251 bytes</td>
																<td>July 10, 2026, 10.35AM</td>
																<td>text/html</td>
																<td>0644</td>
															</tr>
															<tr>
																<td className="text-center"><iconify-icon icon="solar:file-text-bold-duotone" className="text-success d-block fs-20px"></iconify-icon></td>
																<td>.htaccess</td>
																<td>128 KB</td>
																<td>August 05, 2026, 12.49PM</td>
																<td>text/html</td>
																<td>0644</td>
															</tr>
															<tr>
																<td className="text-center"><iconify-icon icon="solar:camera-bold-duotone" className="text-indigo d-block fs-20px"></iconify-icon></td>
																<td>favicon.ico</td>
																<td>2 KB</td>
																<td>July 05, 2026, 7.39AM</td>
																<td>image/x-generic</td>
																<td>0644</td>
															</tr>
														</tbody>
													</table>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
		</div>
	);
}

export default ExtraFileManager;
